import * as React from 'react';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {PageHeader} from 'shells/ai-homepage/page-header/page-header';
import {Stack} from 'shells/layout/stack/stack';
import {AiBadge} from 'shells/summary/ai-badge';

import type {AiFeaturePeriod} from 'nutshell-graphql-types';

import {analyticsClient} from '../../analytics-client';

import {AiPageWrapper} from './ai-page-wrapper';
import {FeaturesSection} from './features/features-section';
import {useGetAiHomepage} from './graphql/hooks/use-get-ai-homepage';
import {handleSelectedUsageTabChange, getSelectedUsageTab} from './helpers';
import {UsageSection} from './usage/usage-section';

type Props = ContextRouter;

export function AiHomepage(props: Props) {
    const selectedUsageTab = getSelectedUsageTab(props.location.search);

    const {aiHomepage, hasAiUsage, isLoading: isLoadingData} = useGetAiHomepage(selectedUsageTab);

    React.useEffect(() => {
        analyticsClient.track(analyticsClient.EVENTS.TRACK_AI_HOMEPAGE_VIEWED);
    }, []);

    return (
        <AiPageWrapper
            tabTitle='AI'
            header={
                <PageHeader
                    title='AI that gives you time back'
                    subTitle='We believe the best technology feels invisible — quietly amplifying your work, not complicating it. Nutshell AI works alongside you, taking care of what’s routine so you can focus on what’s real: the people, the deals, and the stories behind every connection.'
                    accent={<AiBadge size='large' />}
                    illustration='ai-homepage/ai-nutshell-logo'
                />
            }
        >
            <Stack spacing={32}>
                <UsageSection
                    hasAiUsage={hasAiUsage}
                    isLoadingHasAiUsage={isLoadingData}
                    statsSectionProps={{
                        aiFeatureStats: aiHomepage ? aiHomepage.stats : [],
                        topAiUsers: aiHomepage ? aiHomepage.topUsers : [],
                        topAiFeatures: aiHomepage ? aiHomepage.topFeatures : [],
                        numStatColumns: 5,
                        isLoadingData: isLoadingData,
                    }}
                    tabProps={{
                        selectedTab: selectedUsageTab,
                        setSelectedTab: (period: AiFeaturePeriod) =>
                            handleSelectedUsageTabChange(
                                period,
                                props.history,
                                props.location.pathname
                            ),
                    }}
                />
                <FeaturesSection selectedUsageTab={selectedUsageTab} />
            </Stack>
        </AiPageWrapper>
    );
}
